import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { routeCodes } from '../../config/routes';

class Header extends Component {

  render() {
    return (
      <div className="container" id="header">
        <NavLink exact to={routeCodes.HOME}><div className="cc" id="logo-container"></div></NavLink>

        <nav className="navbar navbar-inverse">
        <div className="container-fluid">
            <div className="navbar-header">
            <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
                <span>Show Menu</span>
            </button>
            </div>
            <div className="collapse navbar-collapse" id="myNavbar">
            <div className="nav navbar-nav">
                <div id="links-container" className="container">
                    <div className="row">
                        <div className="cc col-xs-4"><NavLink exact to={routeCodes.ENVIROMENT}>1. Enviroment</NavLink></div>
                        <div className="cc col-xs-4"><NavLink exact to={routeCodes.DATA}>2. Data</NavLink></div>
                        <div className="cc col-xs-4"><NavLink exact to={routeCodes.MODEL}>3. Model</NavLink></div>
                        <div className="cc col-xs-4"><NavLink exact to={routeCodes.STRATEGY}>4. Strategy</NavLink></div>
                        <div className="cc col-xs-4"><NavLink exact to={routeCodes.TRANSFORMATIONS}>5. Transformations</NavLink></div>
                        <div className="cc col-xs-4"><NavLink exact to={routeCodes.FINALTESTS}>6. Final Tests</NavLink></div>
                    </div>
                </div>
                <li className="dropdown">
                </li> 
            </div>
            </div>
        </div>
        </nav>
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/globals/Header.js